import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InboxIcon from '@mui/icons-material/Inbox';

/**
 * @param {{
 *   title: string,
 *   description?: string,
 * }} props
 */
export default function EmptyState({ title, description }) {
  return (
    <Box
      sx={{ display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        gap: 1,
      }}
    >
      <InboxIcon sx={{ fontSize: 48, color: 'var(--grey-300)' }} />
      <Typography sx={{ fontWeight: 600, fontSize: '0.9375rem', color: 'var(--grey-600)', mt: 1 }}>
        {title}
      </Typography>
      {description && (
        <Typography sx={{ fontSize: '0.875rem', color: 'var(--grey-400)', textAlign: 'center', maxWidth: 360 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}
